import { Icon } from '../../Elements'

const LoadingFit = ({
  isLoading,
  className,
  fixed,
}: {
  isLoading: boolean
  className?: string
  fixed?: boolean
}) => {
  return (
    <>
      {isLoading ? (
        <div
          className={`${fixed ? 'fixed ' : 'absolute'
            } w-full h-full z-[99] left-0 right-0 bottom-0 top-0 backdrop-blur-[1px]
       flex justify-center items-center flex-col ${className ?? ''}`}
        >
          <Icon
            icon='rayteb-logo'
            className='text-4xl text-primary animate-ping'
          />
        </div>
      ) : (
        ''
      )}
    </>
  )
}

export default LoadingFit
